var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marketing-link g-clearfix"},[_c('WxOpenBrowserMask',{model:{value:(_vm.showMask),callback:function ($$v) {_vm.showMask=$$v},expression:"showMask"}}),_vm._v(" "),_c('div',{staticClass:"marketing-link_button",style:(_vm.customStyle),on:{"click":_vm.handleClick}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e9f354","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/marketing/components/link.vue
// module id = 616
// module chunks = 1 2